<template>
    <b-card v-if="bookingtemplate">
        <b-card-title>
            {{ bookingtemplate.title }} <i v-if="!work">...</i>
        </b-card-title>
        <b-card-body>
            <div v-if="work && work.booking">
                <b-card key-nav style="background-color:orange" v-if="IsChanged()">
                    <b-row>
                        <b-col cols="1">
                            <b-button @click="Save()">Spara</b-button>
                        </b-col>
                        <b-col cols="1">
                            <b-button v-if="!IsNew()" v-on:click="CancelChanges()">Avbryt</b-button>
                        </b-col>
                    </b-row>
                </b-card>
                <b-button-group v-if="!IsChanged()">
                    <b-button variant="primary" @click="ReleaseBooking()" v-if="!IsChanged() && !IsLocked()"><i
                            class="fa-solid fa-paper-plane"></i> Skicka bokning till transportör</b-button>
                    &nbsp;
                    <b-button variant="outline-secondary" @click="DeleteBooking()" v-if="!IsChanged() && !IsLocked()"><i
                            class="fa-solid fa-xmark"></i> Makulera</b-button>

                    <!-- <b-button variant="outline-secondary" @click="PrintFreightDocs()" v-if="!IsChanged() && IsLocked() && getFreightDocs().length>0" title="Fraktdokument">
                    <i class="fa-solid fa-file-lines"></i> Skriv ut fraktdokument</b-button> -->
                    <b-dropdown variant="outline-secondary"
                        v-if="!IsChanged() && IsLocked() && getFreightDocs().length > 0" title="Fraktdokument">
                        <template #button-content>
                            <i class="fa-solid fa-file-lines"></i> Skriv ut fraktdokument
                        </template>
                        <b-dropdown-item v-for="(ea, i) in getFreightDocs()" :key="i" @click="printFreightDoc(ea)">
                            {{ ea.Description }}
                        </b-dropdown-item>
                    </b-dropdown>
                    &nbsp;

                </b-button-group>

                <b-card>
                    <b-button v-if="!IsLocked()" size="sm" variant="outline-secondary" @click="Validate()"
                        title="Kontrollera om OK"><b-icon-exclamation></b-icon-exclamation> Kontrollera</b-button>
                    <b-alert v-if="errMsgs && errMsgs.length > 0" v-model="errMsgsVisible" variant="danger" dismissible>
                        <li v-for="e in errMsgs" :key="e">{{ e }}</li>
                    </b-alert>
                    <b-row>
                        <b-col>
                            <b-row v-if="IsLocked()">
                                <b-col>
                                    <label>Sändningsnummer:</label>
                                    <br />
                                    <h4>{{ work.booking.TspDocNo }}<clipboardbutton :value="work.booking.TspDocNo">
                                        </clipboardbutton>
                                    </h4>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <label>Datum:</label>
                                    <br />
                                    <datepicker v-model="work.booking.DeliveryDateText" :stepper="true"
                                        :readonly="IsReadonly()">
                                    </datepicker>
                                </b-col>
                                <lfield fieldname="TourName" :fields="bookingtemplate.fields">
                                    <b-col>
                                        <label>Tur:</label>
                                        <br />
                                        <b-form-input v-model="work.booking.TourName"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </lfield>
                                <lfield fieldname="TerminalId" :fields="bookingtemplate.fields">
                                    <b-col>
                                        <label>Terminal:</label>
                                        <br />
                                        <!-- <b-form-input v-model="work.booking.TerminalName" v-bind:readonly="IsReadonly()"></b-form-input> -->
                                        <!-- <b-form-select class="form-control" v-model="work.booking.TerminalId" :options="GetTerminals()" :readonly="IsReadonly()"></b-form-select> -->
                                        <lformselect class="form-control" v-model="work.booking.TerminalId"
                                            :options="GetTerminals()" :readonly="IsReadonly()"
                                            @input="RefreshProductList()"></lformselect>
                                    </b-col>
                                </lfield>
                                <b-col v-if="isFieldVisible('ProductTerminalCombo')">
                                    <label>Transportsätt:</label>
                                    <br />
                                    <lformselect class="form-control" v-model="currProdTerminalCombo"
                                        :options="getProdTerminalComboItems()" :readonly="IsReadonly()"
                                        @input="onChangeCurrProdCombo()"></lformselect>
                                </b-col>
                            </b-row>
                        </b-col>
                        <!-- BIG -->
                        <b-col>
                            <b-row>
                                <lfield :fieldName="'ServiceTypeId'" :fields="bookingtemplate.fields">
                                    <b-col v-if="isFieldVisible('ServiceTypeId')">
                                        <label>Ordertyp:</label>
                                        <br />
                                        <div v-if="IsReadonly()">
                                            {{ GetServiceTypeName(work.booking.ServiceTypeId) }}
                                        </div>
                                        <!-- <b-form-select class="form-control" v-model="work.booking.ServiceTypeId" :options="GetServiceTypes()" v-show="!IsReadonly()"></b-form-select> -->
                                        <lformselect class="form-control" v-model="work.booking.ServiceTypeId"
                                            :options="GetServiceTypes()" v-show="!IsReadonly()"
                                            @input="RefreshProductList()">
                                        </lformselect>
                                    </b-col>
                                </lfield>
                                <lfield fieldname="ProductKey" :fields="bookingtemplate.fields">
                                    <b-col>
                                        <label>Produkt:</label>
                                        <br />
                                        <!-- <b-form-select class="form-control" v-model="work.booking.ProductKey" :options="GetProducts()" :readonly="IsReadonly()"></b-form-select> -->
                                        <lformselect class="form-control" v-model="work.booking.ProductKey"
                                            :options="GetProducts()" :readonly="IsReadonly()"></lformselect>
                                        <!-- <b-form-input v-model="(work.product || { PrettyName: '' }).PrettyName"
                v-bind:readonly="IsReadonly() || true"></b-form-input> -->
                                    </b-col>
                                </lfield>
                                <lfield fieldname="StatusId" :fields="bookingtemplate.fields">
                                    <b-col>
                                        <label>Status:</label>
                                        <br />
                                        {{ GetStatus(work.booking.StatusId) }}
                                    </b-col>
                                </lfield>
                                <b-col>
                                    <div v-if="!work.booking.Locked && !work.pendingRelease">
                                        <b-icon-unlock-fill></b-icon-unlock-fill> Öppen
                                    </div>
                                    <div v-if="!work.booking.Locked && work.pendingRelease">
                                        <b-button variant="light"
                                            :title="`Väntande frisläppning: ${work.pendingRelease.ContextKey}`"><b-icon-clock></b-icon-clock>
                                            {{
        GetPr(work)
    }}</b-button>
                                    </div>
                                    <div v-if="work.booking.Locked">
                                        <b-icon-lock-fill></b-icon-lock-fill> Låst
                                    </div>
                                    <b-button size="sm"
                                        v-if="work.booking.ConsolidationId && work.booking.ConsolidatedCount == 0">Ingår
                                        i
                                        konsolidering</b-button>
                                    <!-- <b-button size="sm" v-if="work.booking.ConsolidatedCount > 0" variant="light">Huvudfrakt i
                                        konsolidering</b-button> -->
                                </b-col>

                            </b-row>
                            <b-row>

                            </b-row>
                            <b-row>
                                <lfield fieldname="EtaMin" :fields="bookingtemplate.fields">
                                    <b-col><label>Sla Min:</label>
                                        <datetimepicker v-model="work.booking.EtaMin" :editMode="!IsReadonly()">
                                        </datetimepicker>
                                    </b-col>
                                </lfield>
                                <lfield fieldname="EtaMax" :fields="bookingtemplate.fields">
                                    <b-col><label>Sla Max:</label>
                                        <datetimepicker v-model="work.booking.Eta" :editMode="!IsReadonly()">
                                        </datetimepicker>
                                    </b-col>
                                </lfield>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card>
                    <b-row>
                        <b-col>

                            <label>Hämtadress:
                                <!-- <b-icon-geo-alt
                                    @click="ShowOnMap(work.booking.PickupPlaceName, work.booking.PickupPlaceStreet, work.booking.PickupPlaceStreet2, work.booking.PickupPlacePostCode, work.booking.PickupPlaceCity)"
                                    title="Visa på karta"></b-icon-geo-alt> -->
                            </label>
                            <b-button v-if="!IsReadonly()" size="sm" variant="outline-secondary" title="Adressregister"
                                @click="selectPlace('Pickup')">Register</b-button>
                            <br />
                            <div>
                                <b-row>
                                    <b-col>
                                        <b-form-input v-model="work.booking.PickupPlaceName" placeholder="Namn"
                                            v-bind:readonly="IsReadonly()" :formatter="formatter"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-input v-model="work.booking.PickupPlaceStreet" placeholder="Gatuadress"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-input v-model="work.booking.PickupPlaceStreet2"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-input v-model="work.booking.PickupPlacePostCode" maxlength="5"
                                            placeholder="Postnr" v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                    <b-col cols="8">
                                        <b-form-input v-model="work.booking.PickupPlaceCity" placeholder="Ort"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <label>Mobiltelefon:</label>
                                        <br />
                                        <b-form-input v-model="work.booking.PickupPhone"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                    <b-col>
                                        <label>Epost:</label>
                                        <br />
                                        <b-form-input v-model="work.booking.PickupEmail"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col>
                            <label>Leveransadress:
                                <!-- <b-icon-geo-alt
                                    @click="ShowOnMap(work.booking.DeliveryPlaceName, work.booking.DeliveryPlaceStreet, work.booking.DeliveryPlaceStreet2, work.booking.DeliveryPlacePostCode, work.booking.DeliveryPlaceCity)"
                                    title="Visa på karta"></b-icon-geo-alt> -->

                            </label>
                            <b-button v-if="!IsReadonly()" size="sm" variant="outline-secondary" title="Adressregister"
                                @click="selectPlace('Delivery')">Register</b-button>
                            <br />
                            <div>
                                <b-row>
                                    <b-col>
                                        <b-form-input v-model="work.booking.DeliveryPlaceName" placeholder="Namn"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-input v-model="work.booking.DeliveryPlaceStreet"
                                            placeholder="Gatuadress" v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-form-input v-model="work.booking.DeliveryPlaceStreet2"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-form-input v-model="work.booking.DeliveryPlacePostCode" maxlength="5"
                                            placeholder="Postnr" v-bind:readonly="IsReadonly()">
                                        </b-form-input>
                                    </b-col>
                                    <b-col cols="8">
                                        <b-form-input v-model="work.booking.DeliveryPlaceCity" placeholder="Ort"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <label>Mobiltelefon:</label>
                                        <br />
                                        <b-form-input v-model="work.booking.DeliveryPhone"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                    <b-col>
                                        <label>Epost:</label>
                                        <br />
                                        <b-form-input v-model="work.booking.DeliveryEmail"
                                            v-bind:readonly="IsReadonly()"></b-form-input>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                    <!-- <b-row>
                        <b-col cols="3">
                            <label>Mobiltelefon:</label>
                            <br />
                            <b-form-input v-model="work.booking.ContactPhone"
                                v-bind:readonly="IsReadonly()"></b-form-input>
                        </b-col>
                        <b-col cols="3">
                            <label>Epost:</label>
                            <br />
                            <b-form-input v-model="work.booking.ContactEmail"
                                v-bind:readonly="IsReadonly()"></b-form-input>
                        </b-col>
                        <b-col cols="3">
                            <label>Vikt (kg):</label>
                            <br />
                            <b-form-input type="number" v-model="work.booking.Weight"
                                v-bind:readonly="IsReadonly()"></b-form-input>
                        </b-col>
                        <b-col cols="3">
                            <label>Volym (m3):</label>
                            <br />
                            <b-form-input type="number" step="0.001" min="0.00" max="99999.00"
                                v-model="work.booking.Volume" v-bind:readonly="IsReadonly()"></b-form-input>
                        </b-col>
                    </b-row> -->
                </b-card>
                <b-card>

                </b-card>
                <b-card>
                    <b-card-body>
                        <label>Kommentar:</label>
                        <br />
                        <b-textarea v-model="work.booking.Comment" v-bind:readonly="IsReadonly()"></b-textarea>
                    </b-card-body>
                </b-card>

                <b-card>
                    <b-card-header>
                        <b-row>
                            <b-col>
                                Kollin <span v-if="work.collis">({{ work.collis.length }}st)</span>
                                <b-icon-eye-fill @click="showCollis = true" v-if="!showCollis"></b-icon-eye-fill>
                                <b-icon-eye-slash-fill @click="showCollis = false"
                                    v-if="showCollis"></b-icon-eye-slash-fill>
                            </b-col>
                            <b-col cols="2">
                                <b-input size="sm" v-model="colliFilter" placeholder="Filtrera kolli..."></b-input>
                            </b-col>

                        </b-row>

                    </b-card-header>
                    <b-card-body v-if="showCollis" class="collibox">
                        <b-row>
                            <b-col>
                                <table>
                                    <thead>
                                        <th></th>
                                        <th v-if="IsReadonly()" @click="SetColliSortOrder('ColliId')" class="clickable">
                                            Kolli Id<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'ColliId'" />
                                        </th>
                                        <th @click="SetColliSortOrder('OrderNo')" class="clickable">OrderNr<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'OrderNo'" />
                                        </th>
                                        <th @click="SetColliSortOrder('TypeOfColli')" class="clickable">Kollityp<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'TypeOfColli'" />
                                        </th>
                                        <th @click="SetColliSortOrder('Description')" class="clickable">
                                            Beskrivning<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'Description'" />
                                        </th>
                                        <!-- <th @click="SetColliSortOrder('Ftx')" class="clickable">Mottagare<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'Ftx'" />
                                        </th> -->
                                        <th @click="SetColliSortOrder('Weight')" class="clickable">Vikt (kg)<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'Weight'" />
                                        </th>
                                        <th @click="SetColliSortOrder('Volume')" class="clickable">Volym (m3)<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'Volume'" />
                                        </th>
                                        <th v-if="IsReadonly()" @click="SetColliSortOrder('Status')" class="clickable">
                                            Status<b-icon
                                                :icon="colliSortOrder > 0 ? 'caret-down-fill' : 'caret-up-fill'"
                                                v-if="colliSortColumn == 'Status'" />
                                        </th>
                                        <th></th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(c, i) in GetCollis(colliFilter, colliSortColumn, colliSortOrder)"
                                            :key="i">
                                            <td>#{{ i + 1 }}
                                            </td>
                                            <td v-if="IsReadonly()" style="width: 25%">
                                                <b-form-input v-model="c.ColliId"
                                                    v-bind:readonly="IsReadonly()"></b-form-input>
                                            </td>
                                            <td style="width: 125px">
                                                <b-form-input v-model="c.OrderNo"
                                                    v-bind:readonly="IsReadonly()"></b-form-input>
                                            </td>
                                            <td style="width: 175px">
                                                <lformselect class="form-control" v-model="c.TypeOfColli"
                                                    :options="GetPackageTypes()" v-show="!IsReadonly()">
                                                </lformselect>
                                                <b-form-input :value="c.TypeOfColli" v-if="IsReadonly()"
                                                    readonly="true"></b-form-input>
                                                <!-- <b-form-input v-model="c.TypeOfColli"
                                                    v-bind:readonly="IsReadonly()"></b-form-input> -->
                                            </td>
                                            <td style="width: 20%">
                                                <b-form-input v-model="c.Description"
                                                    v-bind:readonly="IsReadonly()"></b-form-input>
                                            </td>
                                            <!-- <td style="width: 20%">
                                                <b-form-input v-model="c.Ftx" v-bind:readonly="IsReadonly()"></b-form-input>
                                            </td> -->
                                            <td style="width: 100px">
                                                <b-form-input type="number" v-model="c.Weight"
                                                    v-bind:readonly="IsReadonly()"
                                                    @input="RecalcWeightVol()"></b-form-input>
                                            </td>
                                            <td style="width: 150px">
                                                <b-form-input type="number" v-model="c.Volume"
                                                    v-bind:readonly="IsReadonly()"
                                                    @input="RecalcWeightVol()"></b-form-input>
                                            </td>

                                            <td v-if="IsReadonly()">
                                                <b-badge v-if="readonly && c.events && c.events.length > 0"
                                                    title="Händelser"
                                                    @click="colliToShowEvents = c; colliEventModal = true;"
                                                    variant="secondary">{{
        c.events.length }}<b-icon-clock></b-icon-clock>
                                                    {{ c.status }}</b-badge>
                                            </td>
                                            <td>
                                                <b-button title="Ta bort kolli" v-if="!IsReadonly()" variant="light"
                                                    size="sm" v-on:click="RemoveColli(c)">
                                                    <b-icon-x-circle-fill></b-icon-x-circle-fill>
                                                </b-button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="2">
                                <b-button size="sm" v-on:click="AddColli()" v-show="!IsReadonly()">+ Lägg till
                                    kolli</b-button>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-card v-if="readonly">
                    <b-card-header>
                        <b-row>
                            <b-col>
                                Händelser: <span v-if="work.events">({{ work.events.length }}st)</span>
                                &nbsp;
                                <b-icon-eye-fill @click="showEvents = true" v-if="!showEvents"></b-icon-eye-fill>
                                <b-icon-eye-slash-fill @click="showEvents = false"
                                    v-if="showEvents"></b-icon-eye-slash-fill>

                            </b-col>
                            <b-col cols="2">
                                <b-input size="sm" v-model="eventFilter" placeholder="Filtrera händelser..."></b-input>
                            </b-col>
                        </b-row>
                    </b-card-header>
                    <b-card-body v-if="showEvents" class="collibox">
                        <!-- <br /> -->
                        <eventlist :events="GetEvents(eventFilter)" :attachments="this.work.attachments"></eventlist>
                    </b-card-body>
                </b-card>
            </div>
            <b-modal v-model="placeSelectVisible" ok-only ok-variant="secondary" ok-title="Avbryt">
                <placeselect v-on:placeselected="placeselected"></placeselect>
            </b-modal>
        </b-card-body>
    </b-card>
</template>
<script>
import Datetimepicker from '@/components/datetimepicker.vue';
import datepicker from "../../components/datepicker";
import lformselect from "@/components/l-form-select.vue"
import clipboardbutton from "./../../components/clipboardbutton.vue";
import eventlist from "./eventlist.vue";
import autocomp from "./../../components/autocomp";
import lfield from '@/components/l-field.vue';
import placeselect from "./placeselect.vue";

import moment from "moment";

import { Api } from "../../lib/api";
import Bookingtrenddash from '../dash/bookingtrenddash.vue';
const api = new Api();

export default {
    name: 'bookingltd',
    props: {
        booking: Object,
        readonly: Boolean,
        bookingtemplate: Object,
    },
    components: {
        datepicker,
        Datetimepicker,
        lformselect,
        clipboardbutton,
        eventlist,
        autocomp,
        lfield,
        placeselect,
    },
    data() {
        return {
            basics: null,
            work: {},
            prodTerminalCombos: null,
            currProdTerminalCombo: null,
            showEvents: true,
            showCollis: true,
            colliFilter: null,
            colliSortColumn: null,
            colliSortOrder: 1,
            places: [], //To be implemented
            searchFor: null,
            placeSelectVisible: false,
            placeType: null,
            eventFilter: null,
            errMsgs: [],
            errMsgsVisible: false,
        }
    },
    mounted() {
        this.refreshData();
    },
    watch: {
        booking: function () {
            this.refreshData();
        },
    },
    methods: {
        refreshData() {
            if (this.booking) {
                this.work = JSON.parse(JSON.stringify(this.booking));
                this.addHomeAddress(this.work.booking);
                this.origCopy = JSON.stringify(this.work);

                if (!this.basics) {
                    api.get("/api/booking/getbasics").then((res) => {
                        //this.basics = res.data;
                        this.basics = { ...res.data, ...this.bookingtemplate.basics };
                        if (this.basics.terminals && this.basics.terminals.length > 0 && !this.work.booking.TerminalId)
                            this.work.booking.TerminalId = res.data.terminals[0].terminalId;

                        this.RefreshProductList();
                        this.$forceUpdate();
                    });
                    //this.getData();
                }

            }
        },
        addHomeAddress(b) {
            var f = localStorage.getItem('favplaces');
            if (f && b && !b.Id) {
                let favs = JSON.parse(f);
                var h = favs.find(x => x.isHome);
                if (h) {
                    b.PickupPlaceName = h.Name;
                    b.PickupPlaceStreet = h.Street;
                    b.PickupPlaceStreet2 = h.Street2;
                    b.PickupPlacePostCode = h.PostCode;
                    b.PickupPlaceCity = h.City;
                }
            }
        },
        IsChanged: function () {
            if (this.readonly) return false;
            if (!this.work || !this.origCopy) return false;

            const res = this.IsNew() || !(JSON.stringify(this.work) == this.origCopy);
            return res;
        },
        IsReadonly: function () {
            return (this.work && this.work.isTotalReadonly) || this.readonly;
        },
        IsLocked: function () {
            return (this.work && this.work.booking && this.work.booking.Locked);
        },
        IsNew: function () {
            return this.work && this.work.booking && !this.work.booking.Id;
        },
        GetTerminals: function () {
            return (!this.basics) ? [] :
                this.basics.terminals
                    .map(x => { return { "value": x.terminalId, "text": x.terminalName } })
                    .sort((a, b) => a.text.localeCompare(b.text));
        },
        GetServiceTypes: function () {
            return !this.basics ? [] :
                this.basics.serviceTypes.map((x) => { return { "value": x.ServiceTypeId, "text": x.Name } });
        },
        GetPackageTypes: function () {
            return !this.basics ? [] :
                this.basics.packageTypes.map((x) => { return { "value": x.TypeOfColli, "text": `${x.TypeOfColli}-${x.PackageType}` } });
        },
        GetProducts: function () {
            return !this.basics ? [] :
                this.basics.products.map((x) => { return { "value": x.ProductKey, "text": `${x.TransporterName}-${x.PrettyName}` } });
        },
        RefreshProductList: function () {
            if (this.basics && this.work.booking && this.bookingtemplate) {

                if (this.useProductTerminalCombo()) {
                    var p0 = { serviceTypeId: this.work.booking.ServiceTypeId, sender: this.bookingtemplate.name };
                    api.get('/api/Booking/GetProductTerminalCombos', p0).then(res => {
                        //console.log(res.data);
                        //alert('Fått tag i produkter');
                        this.prodTerminalCombos = res.data;
                        this.setProductTerminalComboFromBooking();
                    });
                };
                if (this.isFieldVisible('ProductKey')) {
                    var p = { serviceTypeId: this.work.booking.ServiceTypeId, terminalId: this.work.booking.TerminalId, sender: this.bookingtemplate.name };
                    api.get('/api/booking/GetBookingProducts', p).then(res => {
                        this.basics.products = res.data;
                        if (res.data && res.data.length > 0) {
                            var pk = this.work.booking.ProductKey;
                            if (!pk || this.basics.products.find(x => x.ProductKey == pk) == null)
                                this.work.booking.ProductKey = this.basics.products[0].ProductKey;
                        }
                    });
                }
            }
        },
        setProductTerminalComboFromBooking() {
            if (this.prodTerminalCombos && this.work && this.work.booking) {
                if (this.work.booking.ProductKey) {
                    var cptc = this.prodTerminalCombos.find(x => x.terminalId == this.work.booking.TerminalId && x.productKey == this.work.booking.ProductKey);
                    if (cptc)
                        this.currProdTerminalCombo = cptc.prettyName;
                } else {
                    if(this.prodTerminalCombos.length == 1) {
                        //Set the only available alternative
                        this.currProdTerminalCombo = this.prodTerminalCombos[0].prettyName;
                        this.onChangeCurrProdCombo();
                    }
                        
                }
            }
        },
        onChangeCurrProdCombo() {
            var pt = this.currProdTerminalCombo;
            if (pt) {
                var ptc = this.prodTerminalCombos.find(x => x.prettyName == pt);
                if (ptc) {
                    this.work.booking.ProductKey = ptc.productKey;
                    this.work.booking.TerminalId = ptc.terminalId;
                    this.work.booking.TerminalName = ptc.terminalName;                    
                }

            }

        },
        getProdTerminalComboItems: function () {
            if (this.prodTerminalCombos && this.useProductTerminalCombo()) {
                return this.prodTerminalCombos.map(x => { return { "value": x.prettyName, "text": x.prettyName } });
            }
            return [];
        },
        isFieldVisible(fieldName) {
            if (this.bookingtemplate && this.bookingtemplate.fields)
                return this.bookingtemplate.fields.visibility.filter(x => x.name == fieldName && x.visible).length > 0;

            return false;
        },
        useProductTerminalCombo: function () {
            return this.isFieldVisible('ProductTerminalCombo');
        },
        RecalcWeightVol: function () {
            if (this.work && this.work.booking && this.work.collis) {
                let totVol = 0;
                let totWeight = 0;
                this.work.collis.map(x => {
                    totVol += Number(x.Volume ?? 0);
                    totWeight += Number(x.Weight ?? 0);
                });
                this.work.booking.Weight = Math.round(totWeight * 100) / 100;
                this.work.booking.Volume = Math.round(totVol * 100) / 100;
            }

        },
        GetServiceTypeName: function (serviceTypeId) {
            if (!this.basics)
                return null;

            var res = this.basics.serviceTypes.find((x) => x.ServiceTypeId == serviceTypeId);
            if (res) return res.Name;
        },
        GetStatus: function (statusId) {
            if (!this.basics || !statusId) return "";
            let s = this.basics.status.find(x => x.StatusId === statusId);
            if (s)
                return s.BookingStatusName;
            return "--";
        },
        SetColliSortOrder(sortColumnName) {
            console.log('SetColliSortOrder:' + sortColumnName);
            if (this.colliSortColumn == sortColumnName) {
                this.colliSortOrder = -this.colliSortOrder;
                return;
            }
            this.colliSortColumn = sortColumnName;
        }
        ,
        GetCollis: function (flt, sortColumn, sortOrder) {
            if (this.work.collis) {
                var res = this.work.collis.filter(x => true); //Make array
                if (flt) {
                    var f = flt.toUpperCase();
                    res = res.filter(c => `${c.ColliId}|${c.OrderNo}|${c.NoOfItems}|${c.TypeOfColli}|${c.Description}|${c.Ftx}|${c.Weight}|${c.Volume}`.toUpperCase().indexOf(f) >= 0);
                }
                if (sortColumn) {
                    res = res.sort((a, b) => a[sortColumn] < b[sortColumn] ? sortOrder : -sortOrder);
                }
                return res;
            }

        },
        AddColli: function () {
            if (!this.work.collis)
                this.work.collis = [];
            this.work.collis.push({ NoOfItems: 1 });
        },
        RemoveColli(c) {
            this.work.collis =
                this.work.collis.filter(function (x) {
                    return x !== c;
                });
        },
        Save() {
            let confText = "Spara ändringar?";
            this.Validate();
            if (this.errMsgs.length > 0) {
                confText = "Det finns valideringsfel. Vill du spara ändå?";
                this.$forceUpdate();
            }
            if (confirm(confText)) {
                var p = JSON.parse(JSON.stringify(this.work));
                p.kpi = null;
                //p.BookingEvents = [];//Avoid sending this back
                api.post('/api/booking/save', p).then((res) => {
                    //this.work.booking = JSON.parse(this.origCopy);
                    if (res.data.errMsg) {
                        alert(res.data.errMsg);
                        return;
                    }
                    this.$emit('change', res.data.booking.Id);
                });
            }
        },
        ValidateField(errs, obj, vo) {
            //vo=fieldName,prettyName,required,minval,maxval,minlength,maxlength
            let v = obj[vo.name];
            let prettyName = vo.title;

            let res = '';
            if (!v && vo.required)
                res = `${prettyName} saknas.`;
            else if (v) {
                if (vo.minval && (v < vo.minval))
                    res = `${prettyName} måste vara minst ${vo.minval}.`;
                else if (vo.maxval && (v > vo.maxval))
                    res = `${prettyName} får max vara ${vo.maxval}.`;
                else if (vo.minlength && v.length < vo.minlength)
                    res = `${prettyName} måste minst ha ${vo.minlength} tecken.`;
                else if (vo.maxlength && v.length > vo.maxlength)
                    res = `${prettyName} får max ha ${vo.maxlength} tecken.`;
            }
            if (errs && res)
                errs.push(res);
            return res;
        },
        Validate() {
            var errs = [];
            if (!this.work)
                errs.push('Ingen bokning är aktiv.')
            else {
                const b = this.work.booking;
                const bcs = this.work.collis;

                // if (!b.ProductKey)
                //     errs.push('Produkt saknas.');
                // if (!b.TerminalId)
                //     errs.push('Terminal är inte vald.');
                // if (!b.ServiceTypeId)
                //     errs.push('Ordertyp är inte vald.');

                if (this.bookingtemplate.fields.validation)
                    this.bookingtemplate.fields.validation.forEach(x => this.ValidateField(errs, b, x));

                // if(!b.Weight || b.Weight <= 0)
                //     errs.push('Vikt saknas');
                // if(!b.Volume || b.Volume <= 0)
                //     errs.push('Volym saknas');
                if (!bcs || bcs.length == 0)
                    errs.push('Kolli saknas.');
                else {
                    let r = 1;
                    bcs.forEach(c => {
                        if (!c.OrderNo)
                            errs.push(`Kolli ${r} saknar ordernummer.`);
                        if (!c.TypeOfColli)
                            errs.push(`Kolli ${r} saknar kollityp.`);
                        if (!c.TypeOfColli)
                            errs.push(`Kolli ${r} saknar kollityp.`);
                        if (!c.Description)
                            errs.push(`Kolli ${r} saknar beskrivning.`);
                        else if (c.Description.length > 35)
                            errs.push(`Kolli ${r} har för lång beskrivning.`);
                        if (!c.Weight || c.Weight <= 0)
                            errs.push(`Kolli ${r} saknar vikt.`);
                        if (!c.Volume || c.Volume <= 0)
                            errs.push(`Kolli ${r} saknar volym.`);
                        r++;
                    });
                }
            }
            this.errMsgs = errs;
            this.errMsgsVisible = (errs.length > 0);
        },
        CancelChanges() {
            this.work = JSON.parse(this.origCopy);
        },
        formatter(s, k, l, m) {
            const maxlength = 150;
            return s.length < maxlength ? s : s.substring(0, maxlength);
        },
        ReleaseBooking() {
            this.Validate();
            if (this.errMsgs && this.errMsgs.length > 0) {
                alert('Det finns fel i bokningen. Vänligen validera dessa först.');
                return;
            }
            if (this.IsChanged()) { //Should not be possible
                alert('Du måste spara eventuella ändringar först!');
                return;
            }
            var msg = `Är du säker på att bokningen skall skickas? Efter att den är skickad går den inte att ändra.`;
            if (confirm(msg)) {
                this.$emit('release', this.work);
            }
        },
        DeleteBooking() {
            if (this.IsChanged()) { //Should not be possible
                alert('Du måste spara eventuella ändringar först!');
                return;
            }
            if (this.IsLocked()) { //Should not be possible
                alert('Bokningen är låst och går inte att ta bort');
                return;
            }

            var msg = `Är du säker på att bokningen skall tas bort? Detta går inte att ångra.`;
            if (confirm(msg)) {
                this.$emit('deletebooking', this.work);
            }
        },
        GetEvents: function () {
            if (!this.work.events)
                return [];
            if (!this.eventFilter)
                return this.work.events;

            let f = this.eventFilter.toLowerCase();
            return this.work.events.filter(x => `${x.Comment}|${x.EventTypeName}|${x.BarCode}`.toLowerCase().indexOf(f) >= 0);


            //.sort((a,b)=> a.RegTime >= b.RegTime);
            //.sort((a, b) => b.RegTime.localeCompare(a.RegTime));
        },
        getPlaces(ev) {
            // console.log("getPlaces:" + ev);
            var flt = ev;
            //this.places.push({ text: "Ny", id: 44 });
            if (flt && flt.length > 0) {
                var p = api.params({ filter: flt });
                api.get("/api/place/GetPlaces?" + p).then((res) => {
                    this.places = res.data;
                });
            }
        },
        selectPlace(type) {
            //type = Pickup, Delivery
            this.placeType = type;
            this.placeSelectVisible = true;
        },
        placeselected(p) {
            let b = this.work.booking;

            if (b) {
                let f = this.placeType;
                b[f + 'PlaceName'] = p.Name;
                b[f + 'PlaceStreet'] = p.Street;
                b[f + 'PlaceStreet2'] = p.Street2;
                b[f + 'PlacePostCode'] = p.PostCode;
                b[f + 'PlaceCity'] = p.City;
                b[f + 'Phone'] = p.ContactPhone;
                b[f + 'Email'] = p.ContactEmail;

                this.placeSelectVisible = false;
            }
        },
        getFreightDocs() {
            if (this.work && this.work.events && this.work.attachments) {
                var evIds = this.work.events.filter(x => x.EventTypeId == 9910).map(x => x.EventId);
                return this.work.attachments.filter(x => evIds.indexOf(x.EventId) >= 0);
            }
            return [];
        },
        printFreightDoc(e) {
            window.open(e.Link);
        }
    }
}




</script>
<style>
.form-control {
    height: auto;
}

.routerows {
    border: darkblue;
    border-bottom-style: dotted;
}

.collibox {
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
}
</style>